import Data from './index';
import { getAssetsPath } from 'common';

Data._loadingSection = [];

export async function loadData(locale) {
  const [items, strings, stats, skills] = await Promise.all(
    ['items.json', 'strings.json', 'stats.json', 'skills.json'].map(name => fetch(getAssetsPath(name, locale)).then(r => r.json()))
  );
  Data.items = items;
  Data.strings = strings;
  Object.assign(Data, stats);
  Data.skills = skills;

  for (const [id, item] of Object.entries(Data.items)) {
    const card = item.card && Data.cards[item.card];
    if (card) card.item = parseInt(id);
  }

  Data._loadSection = function(index) {
    if (!this._loadingSection[index]) {
      this._loadingSection[index] = fetch(getAssetsPath(`items${index}.json`, locale)).then(r => r.json()).then(data => Object.assign(this.items, data));
    }
    return this._loadingSection[index];
  };

  Data.loadItem = async function(id) {
    if (!this.items[id] && this.compact && !this.money[id]) {
      id = parseInt(id);
      const index = this.itemSplits.findIndex(m => m > id);
      return this._loadSection(index);
    }
    return this.items[id];
  };
  Data.loadItems = async function(ids) {
    if (!this.compact) return;
    const sections = [...new Set(ids.filter(id => !this.items[id] && !this.money[id]).map(id => this.itemSplits.findIndex(m => m > id)))];
    if (!sections.length) return;
    return Promise.all(sections.map(index => this._loadSection(index)));
  };

  Data.loaded = true;
}

export async function loadAllItems(locale) {
  const loaded = loadData(locale);
  for (let index = 0; index < Data.itemSplits.length; ++index) {
    if (!Data._loadingSection[index]) {
      Data._loadingSection[index] = fetch(getAssetsPath(`items${index}.json`, locale)).then(r => r.json()).then(async data => {
        await loaded;
        if (Data.compact) {
          Object.assign(Data.items, data);
        }
      });
    }
  }
  await loaded;
  await Promise.all(Data._loadingSection);
};
